export default "__VITE_ASSET__StW6r9UQ__"